import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'flashreport',
    pathMatch: 'full',
  },
  {
    // Legacy Cognito callback path — kept so old bookmarks still land somewhere sane
    path: 'dashboard',
    redirectTo: 'flashreport',
    pathMatch: 'full',
  },
  {
    path: 'flashreport',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/reports/flash-report/flash-report.component').then(
        (c) => c.FlashReportComponent
      ),
  },
  {
    path: 'viewflashreport',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/reports/view-flash-report/view-flash-report.component').then(
        (c) => c.ViewFlashReportComponent
      ),
  },
  {
    path: 'slatesummary',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/reports/slate-summary/slate-summary.component').then(
        (c) => c.SlateSummaryComponent
      ),
  },
  {
    path: 'flashsummary',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/reports/flash-summary/flash-summary.component').then(
        (c) => c.FlashSummaryComponent
      ),
  },
  {
    path: 'mediasummary',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/reports/media-summary/media-summary.component').then(
        (c) => c.MediaSummaryComponent
      ),
  },
  {
    path: 'departmentsummary',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/reports/department-summary/department-summary.component').then(
        (c) => c.DepartmentSummaryComponent
      ),
  },
  {
    path: 'viewreports',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/reports/view-reports/view-reports.component').then(
        (c) => c.ViewReportsComponent
      ),
  },
  {
    path: 'publishreportstest',
    canActivate: [authGuard],
    data: { requiresAdmin: true },
    loadComponent: () =>
      import('./features/reports/publish-test/publish-test.component').then(
        (c) => c.PublishTestComponent
      ),
  },
  {
    path: 'adduser',
    redirectTo: 'manageusers',
    pathMatch: 'full',
  },
  {
    path: 'manageusers',
    canActivate: [authGuard],
    data: { requiresAdmin: true },
    loadComponent: () =>
      import('./features/users/manage-users/manage-users.component').then(
        (c) => c.ManageUsersComponent
      ),
  },
  {
    path: 'managetitle',
    canActivate: [authGuard],
    data: { requiresAdmin: true },
    loadComponent: () =>
      import('./features/users/title-permissions/title-permissions.component').then(
        (c) => c.TitlePermissionsComponent
      ),
  },
  {
    path: 'manageusers/title',
    redirectTo: 'managetitle',
    pathMatch: 'full',
  },
  {
    path: 'managegroups',
    canActivate: [authGuard],
    data: { requiresAdmin: true },
    loadComponent: () =>
      import('./features/groups/manage-groups/manage-groups.component').then(
        (c) => c.ManageGroupsComponent
      ),
  },
  {
    path: 'autherror',
    loadComponent: () =>
      import('./shared/components/not-found/not-found.component').then(
        (c) => c.NotFoundComponent
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./shared/components/not-found/not-found.component').then(
        (c) => c.NotFoundComponent
      ),
  },
];
